import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext({ lang: "en", t: translations.en, setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("mitrollari_lang") || "en";
  });

  useEffect(() => {
    localStorage.setItem("mitrollari_lang", lang);
    document.documentElement.lang = lang;
    document.title =
      lang === "el"
        ? "MITROLLARI ENGINEERING — Ολικές Ανακαινίσεις & Κατασκευές | Αθήνα · Κύθηρα"
        : "MITROLLARI ENGINEERING — Full Renovations & Construction | Athens · Kythira";
  }, [lang]);

  const value = { lang, setLang, t: translations[lang] || translations.en };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
